import { BaseErrorLayout } from '@dvb/ui';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { NavigationBar } from '@school-manage/ui/NavigationBar/NavigationBar';
import { useTranslation } from 'react-i18next';

export function HomeError() {
  const { t } = useTranslation();

  return (
    <>
      <HeaderBar hasSettingBtn title={t('home')} />
      <BaseErrorLayout className="bg-background w-full" />
      <NavigationBar />
    </>
  );
}
